var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "url(#paint0_linear_1275_22500)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7889 29.0525L37.4302 25.2289C37.7815 25.0264 38 24.6494 38 24.2444V16.5959C38 16.1916 37.7815 15.814 37.4302 15.6115L30.7889 11.7879C30.4377 11.5854 30.0007 11.586 29.6494 11.7879L23.0081 15.6115C22.6569 15.814 22.4384 16.191 22.4384 16.5959V30.2631L17.7814 32.9438L13.1245 30.2631V24.8999L17.7814 22.2192L20.8535 23.9874V20.3899L18.3512 18.9495C18.1785 18.8503 17.9815 18.7981 17.7814 18.7981C17.5814 18.7981 17.3843 18.8503 17.2117 18.9495L10.5698 22.7738C10.2185 22.9762 10 23.3533 10 23.7582V31.4061C10 31.8104 10.2185 32.188 10.5698 32.3906L17.2111 36.2147C17.5623 36.4166 17.9987 36.4166 18.3506 36.2147L24.9919 32.3912C25.3431 32.1886 25.5616 31.811 25.5616 31.4067V17.7395L25.6456 17.6914L30.2186 15.0588L34.8754 17.7401V23.1027L30.2186 25.784L27.1513 24.0182V27.6157L29.6488 29.0543C30.0001 29.2562 30.4371 29.2562 30.7883 29.0543L30.7889 29.0525Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1275_22500",
    x1: 0,
    y1: 0,
    x2: 41.7177,
    y2: 52.9497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.144679,
    stopColor: "#982ECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85326,
    stopColor: "#7C3FE4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.0de2da876c41d036dbcd4fb9fe834fa3.svg";
export { ForwardRef as ReactComponent };